function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//@ts-nocheck

/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export class DateService {
  constructor() {
    _defineProperty(this, "locale", void 0);
  }

  setLocale(locale) {
    this.locale = locale;
  }

  compareDatesSafe(date1, date2) {
    if (date1 && date2) {
      return this.compareDates(date1, date2);
    } else if (!date1 && !date2) {
      return 0;
    }

    return -1;
  }
  /**
   * Checks if the date is between the start date and the end date.
   * */


  isBetween(date, start, end) {
    return this.compareDates(date, start) > 0 && this.compareDates(date, end) < 0;
  }
  /**
   * Checks if the date is between the start date and the end date.
   * */


  isBetweenSafe(date, start, end) {
    return date && start && end && this.compareDates(date, start) > 0 && this.compareDates(date, end) < 0;
  }
  /**
   * Checks if the date is between the start date and the end date including bounds.
   * */


  isBetweenIncluding(date, start, end) {
    return this.compareDates(date, start) >= 0 && this.compareDates(date, end) <= 0;
  }
  /**
   * Checks if the date is between the start date and the end date including bounds.
   * */


  isBetweenIncludingSafe(date, start, end) {
    return date && start && end && this.isBetweenIncluding(date, start, end);
  }
  /**
   * Checks is two dates have the same day.
   * */


  isSameDaySafe(date1, date2) {
    return date1 && date2 && this.isSameDay(date1, date2);
  }
  /**
   * Checks is two dates have the same month.
   * */


  isSameMonthSafe(date1, date2) {
    return date1 && date2 && this.isSameMonth(date1, date2);
  }
  /**
   * Checks is two dates have the same year.
   * */


  isSameYearSafe(date1, date2) {
    return date1 && date2 && this.isSameYear(date1, date2);
  }
  /**
   * Returns true if date string is valid date string according to the provided format.
   * */


}

_defineProperty(DateService, "DAYS_IN_WEEK", 7);

_defineProperty(DateService, "MONTHS_IN_YEAR", 12);